import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { IntegerInput } from "components/Global/FormikMaterial";

const MinWidthGrid = styled(Grid)`
  &&&& {
    min-width: ${props => props.minWidth}px;
    height:68px;

  }
`;
const InterestOnlyAmortVariant = ({ }) => (
  <MinWidthGrid container alignItems="center" item xs={2} sm={2} md={2} lg={2} xl={2} minWidth={140} />
);
export default InterestOnlyAmortVariant;
